module.exports = __webpack_public_path__ + "img/tag3.e8382d47.png";